import React, { useState, useEffect } from 'react';
import Producer from 'components/ProducerManagement/Products';
import Board from 'components/ProducerManagement/Board';
import Regional from 'components/ProducerManagement/Regional';
import Channel from 'components/ProducerManagement/Channel';
import Uf from 'components/ProducerManagement/Uf';
import Results from 'components/ProducerManagement/Results';
import getProducts from 'services/ProductsManager/products';
import getFilters from 'services/ProductsManager/filters';
import getCampaigns from 'services/cockpit/getCampaign';

import {
  Container,
  Header,
  Body,
  FilterBox,
  AllFilters,
  BoxFilters,
  Result,
} from './styles';

interface Item {
  value: string;
  label: string;
}

interface FiltersOptions {
  directory?: Item[];
  region?: Item[];
  channel?: Item[];
  uf?: Item[];
}

interface Campaign {
  id: number;
  isTerraBrasil: boolean;
  label: string;
}

const ProductManagements: React.FC = () => {
  const [campaigns, setCampaigns] = useState<Campaign[]>([]);
  const [productsItens, setProductsItens] = useState<Item[]>([]);
  const [filtersOptios, setFiltersOptios] = useState<any>();
  const [filter, setFilter] = useState<FiltersOptions>({
    directory: [],
    region: [],
    channel: [],
    uf: [],
  });
  const [filterSafraFirstBlock, setFilterSafraFirstBlock] = useState<number>(0);
  const [filterSafraSecundBlock, setFilterSafraSecundBlock] = useState<number>(0);

  const [clear, setClear] = useState<boolean | null>(false);

  const [produtos, setProdutos] = useState<Item | null>();
  const [board, setBoard] = useState<Item | null>();
  const [regional, setRegional] = useState<Item | null>();
  const [channel, setChannel] = useState<Item | null>();
  const [uf, setUf] = useState<Item | null>();

  useEffect(() => {
    const loadLink = async () => {
      const responseData = await getProducts();
      setProductsItens(responseData);
    };
    loadLink();
  }, []);

  useEffect(() => {
    setFilter({
      directory: board?.value ? [board] : [],
      region: regional?.value ? [regional] : [],
      channel: channel?.value ? [channel] : [],
      uf: uf?.value ? [uf] : [],
    });
  }, [board, regional, channel, uf]);

  useEffect(() => {
    const loadLink = async () => {
      if (!produtos || !filter) return;
      const responseData = await getFilters(produtos?.value || '', filter);
      console.log(responseData)
      setFiltersOptios(responseData); // Verifique se o nome da função está correto
    };

    loadLink();
  }, [filter, produtos]);

  useEffect(() => {
    const fetchCampaign = async () => {
      const data = await getCampaigns();

      const dataFilter = data.filter(item => {
        return item.isTerraBrasil === false;
      });

      setCampaigns(dataFilter); // Assuming you want to set the filtered campaign
    };
    fetchCampaign();
  }, []);

  useEffect(() => {
    if (campaigns.length > 0) {
      // const maiorValor = Math.max(...campaigns.map(item => item.id));
      // setFilterSafra(maiorValor);

      const sortedCampaigns = [...campaigns].sort((a, b) => b.id - a.id);

      setFilterSafraFirstBlock(sortedCampaigns[0].id);
      setFilterSafraSecundBlock(sortedCampaigns[1].id);
    }
  }, [campaigns]);

  const handleProducer = (value: { value: string; label: string } | null) => {
    if (value === null) {
      setBoard(value);
      setRegional(value);
      setChannel(value);
      setUf(value);
      setFiltersOptios(value);
      setClear(true);
    }
    setProdutos(value);
  };

  const handleBoard = (value: { value: string; label: string } | null) => {
    setBoard(value);
  };

  const handleRegional = (value: { value: string; label: string } | null) => {
    setRegional(value);
  };

  const handleChannel = (value: { value: string; label: string } | null) => {
    setChannel(value);
  };

  const handleUf = (value: { value: string; label: string } | null) => {
    setUf(value);
  };

  const resetClear = (value: boolean | null) => {
    setClear(value);
  };

  return (
    <Container>
      <Header>
        <FilterBox>
          <h1>Gestão de Produtos</h1>
          <Producer
            options={productsItens}
            Title={'Produtos FMC'}
            placeholder={'Selecione um produto'}
            onChange={handleProducer}
          />

          <AllFilters>
            <BoxFilters>
              <Board
                options={filtersOptios?.directory || []}
                Title={'Diretoria'}
                placeholder={'Selecione uma diretoria'}
                onChange={handleBoard}
                Clear={clear}
                resetClear={resetClear}
              />
            </BoxFilters>
            <BoxFilters>
              <Regional
                options={filtersOptios?.region || []}
                Title={'Regional'}
                placeholder={'Selecione uma regional'}
                onChange={handleRegional}
                Clear={clear}
                resetClear={resetClear}
              />
            </BoxFilters>
            <BoxFilters>
              <Channel
                options={filtersOptios?.channel || []}
                Title={'Canal'}
                placeholder={'Selecione um canal'}
                onChange={handleChannel}
                Clear={clear}
                resetClear={resetClear}
              />
            </BoxFilters>
            <BoxFilters>
              <Uf
                options={filtersOptios?.uf || []}
                Title={'UF'}
                placeholder={'Selecione uma UF'}
                onChange={handleUf}
                Clear={clear}
                resetClear={resetClear}
              />
            </BoxFilters>
          </AllFilters>
        </FilterBox>
      </Header>
      <Body>
        <Result>
          <h1>{produtos?.value}</h1>
          {produtos && (
            <>
              <Results
                Products={produtos}
                Filters={filter}
                Campaign={campaigns}
                initialCampaign={filterSafraFirstBlock}
                borderColor={'#821C0E'}
                color={'#821C0E'}
              />
              <Results
                Products={produtos}
                Filters={filter}
                Campaign={campaigns}
                initialCampaign={filterSafraSecundBlock}
                borderColor={'#cccccc'}
                color={'#474747'}
              />
            </>
          )}
        </Result>
      </Body>
    </Container>
  );
};

export default ProductManagements;
